import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ListQueryParam } from '../../../../common/constants/list-query-param.constant';
import { DEFAULT_LIST_QUERY_PARAM_LIMIT } from '../../../../common/models/list.model';
import { AddressModel } from '../../../../common/models/address.model';
import { getQueryStringFromObject, transformAddressDetailsIntoModel } from '../../../../common';
import { AddressEndpoint } from '../constants/address-endpoint';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services/config';
import { AddressDetailsModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AddressOptionsService {
  constructor(private http: WrapperHttpService) {}

  getAddresses(filter: string): Observable<AddressModel[]> {
    const url = `${API_URL}${AddressEndpoint.Base}?${getQueryStringFromObject({
      [ListQueryParam.Limit]: DEFAULT_LIST_QUERY_PARAM_LIMIT,
      filter,
    })}`;
    return this.http
      .withLoading()
      .get<AddressDetailsModel[]>(url)
      .pipe(map((response: AddressDetailsModel[]) => transformAddressDetailsIntoModel(response)));
  }

  getDetailedAddresses(filter: string): Observable<AddressDetailsModel[]> {
    const url = `${API_URL}${AddressEndpoint.Base}?${getQueryStringFromObject({
      [ListQueryParam.Limit]: DEFAULT_LIST_QUERY_PARAM_LIMIT,
      filter,
    })}`;
    return this.http
      .withLoading()
      .get<AddressDetailsModel[]>(url)
      .pipe(map((response: AddressDetailsModel[]) => response));
  }
}
